import React, { useEffect } from "react";
import { Listbox } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/solid";

export default function Dropdown({
  label,
  field_name,
  error,
  required,
  onChange,
  values,
  borderColor,
  value,
  showTitle,
  title,
  activeElement,
  setActiveElement,
}) {
  const selectedOption = values.find((item) => item.value === value)?.label || "";
  const [selected, setSelected] = React.useState(selectedOption);
  const [open, setOpen] = React.useState(false);

  useEffect(() => {
    setSelected(selectedOption);
    setOpen(false);
  }, [selectedOption]);

  const select = (selectedValue) => {
    setSelected(selectedValue.label);
    onChange(field_name, selectedValue.value);
    setActiveElement(field_name);
    setOpen(false);
  };

  return (
    <div className="w-full relative">
      {showTitle && (
        <label className="block text-sm font-normal mb-2 ml-1">
          {title}
          {`${required ? "*" : ""}`}
        </label>
      )}
      <Listbox value={{ label: selected }} onChange={select}>
        <Listbox.Button
          onClick={() => {
            setOpen(activeElement !== field_name ? true : !open);
            setActiveElement(field_name);
          }}
          className={`peer border flex justify-between items-center h-12 w-full disabled:opacity-60 ${
            error ? "!text-red-600" : "!text-gray-800"
          } px-4 py-2 bg-white text-md
            font-medium rounded-lg placeholder-transparent outline-none pl-6 ${
              error ? "ring-err-base" : ""
            } input-invalid`}
          style={{ borderColor: error ? "#dc2626" : borderColor }}
        >
          {selected && <label className="whitespace-nowrap text-left overflow-hidden">{selected}</label>}
          {!selected && label && (
            <label className="text-gray-400 text-base">
              {label}
              {required && <span>*</span>}
            </label>
          )}
          <span className="">
            <ChevronDownIcon
              className="h-5 w-5 text-gray-400"
              aria-hidden="true"
            />
          </span>
        </Listbox.Button>
        {open && activeElement === field_name && (
          <Listbox.Options static className="absolute mt-1 z-50 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
            {values.map((option) => (
              <Listbox.Option
                key={option.value}
                className={({ active }) =>
                  `relative cursor-default select-none py-2 pl-6 pr-4 ${
                    active ? "bg-neutral-100 text-black" : "bg-white text-black"
                  }`
                }
                value={option}
              >
                {({ selected }) => (
                  <span className={`block ${selected ? "font-medium" : "font-normal"}`}>
                    {option.label}
                  </span>
                )}
              </Listbox.Option>
            ))}
          </Listbox.Options>
        )}
      </Listbox>
      {value && !showTitle && (
        <label
          className="
            absolute rounded-lg bg-white text-xs left-0 -top-2 ml-4 pt-1 px-2
            peer-placeholder-shown:text-md peer-placeholder-shown:text-gray-400 peer-placeholder-shown:top-3
            peer-focus:text-xs text-gray-400 peer-focus:peer-valid::text-prm-base peer-focus:text-prm-base
            peer-focus:-top-2 transition-all label-invalid
          "
        >
          {label}
          {required && <span>*</span>}
        </label>
      )}
      {error && (
        <div className="text-red-600 ml-4 text-sm px-2 -bottom-1 bg-white rounded absolute">
          {error}
        </div>
      )}
    </div>
  );
}
